import { createFeature, createReducer, on } from '@ngrx/store';
import { logoutOAuth } from '../actions/session-auth.actions';
import { userProfileFetched } from '../actions/session-profile.actions';
import { widgetsOrderSaved } from '../actions/widgets.actions';
import { WidgetId } from '../selectors/widgets.selector';

export const WIDGETS_STATE_KEY = 'widgets';

export type WidgetsState = {
  widgetsOrder: WidgetId[] | null;
  widgetsCountPerLine: number[];
};

const initialState: WidgetsState = {
  widgetsOrder: null,
  widgetsCountPerLine: [2, 1, 2],
};

const reducer = createReducer(
  initialState,
  on(logoutOAuth, () => initialState),
  on(userProfileFetched, (state, { userProfile }) => ({
    ...state,
    widgetsOrder: userProfile.dashboard_configuration,
  })),
  on(widgetsOrderSaved, (state, { widgetsOrder }) => ({
    ...state,
    widgetsOrder,
  })),
);

export const widgetsFeature = createFeature({
  name: WIDGETS_STATE_KEY,
  reducer,
});
